<div class="promo-wrapper">
  <span class="lib-badge bg-yellow" *ngIf="isNew">newly added</span>
  <ngx-picture alt="" [src]="preview" [lazyLoad]="true"></ngx-picture>
</div>
<div class="content">
  <div class="logo-wrapper" [style.width]="logoWidth">
    <ngx-picture [src]="logo" alt="" [lazyLoad]="true"></ngx-picture>
  </div>
  <ng-content></ng-content>
  <nav class="lib-nav">
    <a [href]="retailerLink" target="_blank" [hidden]="!retailerLink">
      <lib-button theme="flat">Go to retailer</lib-button>
    </a>
    <span class="lib-spacer"></span>
    <a [href]="claimLink" target="_blank" [hidden]="!claimLink">
      <lib-button theme="flat-link" prefixIcon="heart">Claim perk</lib-button>
    </a>
  </nav>
</div>
